import { ApiEndpointClient } from './resource-client';
const CONFIG_API_PREFIX = 'config-api/v1';
export class FeaturesClient extends ApiEndpointClient {
    constructor(http) {
        super(http, CONFIG_API_PREFIX);
    }
    getAppraiserUiFeatureFlags = async () => {
        return this.get('/features/', { response: 'content-type-or-empty' });
    };
    getClientPortalFeatureFlags = async ({ customerUuid } = {}) => {
        const query = customerUuid ? { customer_uuid: customerUuid } : undefined;
        return this.get('/features/', { response: 'content-type', query });
    };
}
